'use strict';

import { module } from '../app';
import * as commonConstants from "../constants/constantStrings";

module.service('versionCheckService', ['$http', '$interval', '$window', 'modalService', 'techpadConfig', '$state',
  function ($http, $interval, $window, modalService, techpadConfig, $state) {

    const CONFIG = {
      CHECK_INTERVAL: 30 * 60 * 1000,
      MAX_RETRY_ATTEMPTS: 3,
      RETRY_DELAY: 30 * 1000,
    };

    const LOGIN_STATE = 'login';
    
    let versionCheckIntervalPromise = null;
    let retryCount = 0;
    let retryTimeoutPromise = null;

    const showErrorModal = (message) => {
      modalService.showAlert(message, commonConstants.DEFAULT_POPUP_HEADER);
    };

    const processVersionResponse = (responseData) => {
      if (!responseData || !responseData.version) {
        throw new Error(commonConstants.VERSION_INVALID_FORMAT_ERROR);
      }
      return responseData.version;
    };
    
    const service = {
      init: function() {
        this.startVersionCheck();
      },

      startVersionCheck: function() {
        this.cleanupTimers();
        this.checkVersion();

        versionCheckIntervalPromise = $interval(() => {
          this.checkVersion();
        }, CONFIG.CHECK_INTERVAL);
      },

      cleanupTimers: function() {
        if (versionCheckIntervalPromise) {
          $interval.cancel(versionCheckIntervalPromise);
          versionCheckIntervalPromise = null;
        }
        
        if (retryTimeoutPromise) {
          clearTimeout(retryTimeoutPromise);
          retryTimeoutPromise = null;
        }
      },
      
      checkVersion: async function() {
        const currentVersion = techpadConfig.appVersionNumber;
        const cacheBuster = new Date().getTime();
        
        try {
          const response = await $http.get(`${commonConstants.VERSION_CHECK_API_PATH}?v=${cacheBuster}`);
          retryCount = 0;
          
          const serverVersion = processVersionResponse(response.data);
          
          if (serverVersion && serverVersion !== currentVersion) {
            const isLoginPage = $state.current.name === LOGIN_STATE || !$state.current.name;
            this.reloadApplication(!isLoginPage, false);
          }
        } catch (error) {
          console.error('Version check failed:', error.message || error);          
          
          if (retryCount < CONFIG.MAX_RETRY_ATTEMPTS) {
            retryCount++;                          
            retryTimeoutPromise = setTimeout(() => {
              this.checkVersion();
            }, CONFIG.RETRY_DELAY);
          } else {
            retryCount = 0;
          }
        }
      },
      
      clearCaches: async function () {
        if ('caches' in window) {
          try {
            const cacheNames = await caches.keys();
            await Promise.all(
              cacheNames.map((cacheName) => {
                return caches.delete(cacheName);
              })
            );
            console.log('All caches cleared');
          } catch (err) {
            console.error('Failed to clear caches:', err);
            showErrorModal(commonConstants.FAILED_TO_CLEAR_CACHE);
          }
        }
      },
      
      reloadApplication: async function(showConfirmation = true, isFromOptionsPage = false) {
        try {
          const performReload = async () => {
            await this.clearCaches();
            const cacheBuster = new Date().getTime();
            $window.localStorage.clear();
            $window.sessionStorage.clear();
            window.location.replace(`${window.location.origin}?v=${cacheBuster}`);
          };
          
          if (showConfirmation) {
            const confirmationMessage = isFromOptionsPage 
              ? commonConstants.CLEAR_CACHE_CONFIRMATION_MESSAGE 
              : commonConstants.CLEAR_CACHE_WARNING_MESSAGE;
            
            modalService.showConfirmation(performReload, 
              confirmationMessage, 
              { title : commonConstants.CLEAR_CACHE_CONFIRMATION_TITLE });
          } else {
            await performReload();
          }
        } catch (error) {
          console.error('Failed to reload application:', error);
          showErrorModal(commonConstants.VERSION_RELOAD_ERROR);
        }
      },

      destroy: function() {
        this.cleanupTimers();
      }
    };
    
    return service;
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/versionCheck.service.js